<template>
    <div class="job-inventory">
        <span v-if="loadingInventory">Loading inventory, please wait...</span>
        <span v-if="!loadingInventory && !inventory">No inventory required</span>
        <p v-if="inventory && inventory.length">
            Inventory:
        </p>
        <p v-if="inventory && inventory.length === 0">
            No inventory to show
        </p>
        <table
            v-if="inventory && inventory.length > 0"
            class="table"
        >
            <tr>
                <th>Type</th>
                <th>Size</th>
                <th>Qty</th>
            </tr>
            <tr
                v-for="(item, index) in inventory"
                :key="index"
            >
                <td>{{ item.name }}</td>
                <td>{{ item.size }}</td>
                <td>x{{ item.quantity }}</td>
            </tr>
        </table>
        <p v-if="batteries && batteries.length > 0">
            Batteries:
        </p>
        <p v-if="batteries && batteries.length == 0">
            No batteries to show
        </p>
        <table
            v-if="batteries && batteries.length > 0"
            class="table"
        >
            <tr>
                <th>Size(Amps)</th>
                <th>Amps</th>
                <th>Volts</th>
                <th>Year</th>
            </tr>
            <tr
                v-for="(battery, index) in batteries"
                :key="index"
            >
                <td>{{ battery.size }}</td>
                <td>{{ battery.amps }}</td>
                <td>{{ battery.volts }}</td>
                <td>{{ battery.year }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
import JobService from '../../services/JobService';

export default {
    props: {
        job: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            inventory: null,
            batteries: null,
            loadingInventory: false,
        };
    },

    mounted() {
        if (!this.inventory) {
            this.loadInventory();
        }
    },

    methods: {
        loadInventory() {
            this.loadingInventory = true;
            JobService.inventory(this.job.id).then(({ data }) => {
                this.inventory = data.items;
                this.batteries = data.batteries;
                this.loadingInventory = false;
            });
        },
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/engineer/JobInventoryComponent.vue